// extracted by mini-css-extract-plugin
module.exports = {"container":"_1oEz5","title":"TeAvN","text":"_2A9sy"};